/* global tinymce:true */
/* global $:true */

/* eslint-disable */

tinymce.PluginManager.add('linktools', function(editor)
{
    function gotoLink()
    {
        return function()
        {
            var url = $(editor.selection.getNode()).attr('href');

            if (url)
            {
                if (url.indexOf('http://') == -1 && url.indexOf('https://') == -1)
                {
                    url = editor.settings.document_base_url + url;
                }

                window.open(url);
            }

            return '';
        };
    }

    function addButtons()
    {
        editor.addButton('gotolink', {
            title: 'Preview',
            onclick: gotoLink()
        });
    }

    function isEditableLink(url)
    {
        // Fix for multiple toolbar visible
        tinymce.each(editor.contextToolbars || [], function(toolbar)
        {
            if (toolbar.panel)
            {
                // Fix for wrong mce-active behavior on toolbar
                tinymce.each(toolbar.panel.find('button'), function(element)
                {
                    element.parent().$el.find('.mce-active').removeClass('mce-active');
                });

                toolbar.panel.hide();
            }
        });

        var selectorMatched = editor.dom.is(url, 'a:not([data-mce-object],[data-mce-placeholder])');

        return selectorMatched;
    }

    function addToolbars()
    {
        var toolbarItems = editor.settings.linktools_toolbar;

        if (!toolbarItems)
        {
            toolbarItems = 'gotolink unlink | link';
        }

        editor.addContextToolbar(
            isEditableLink,
            toolbarItems
        );
    }

    addButtons();
    addToolbars();
});
